import React from 'lib/react';
import { EVTooltip } from 'lib/components';
import ProductStyles from './ProductStyles';

function ProductTooltip(props) {
  const classes = ProductStyles();

  return (
    <EVTooltip
      interactive
      arrow
      placement="left"
      enterDelay={0}
      {...props}
      classes={{ arrow: classes.arrow, tooltip: classes.tooltip }}
    />
  );
}

export default ProductTooltip;
